import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.local';
import {BehaviorSubject, Observable} from 'rxjs';
import {UtilisateurResponse, UtilisateursResponse} from '../../models/utilisateur/UtilisateurResponse';
import {UtilisateurBody} from '../../models/utilisateur/UtilisateurBody';
import {UtilisateurDeleteResponse} from '../../models/utilisateur/UtilisateurDeleteResponse';

@Injectable({
  providedIn: 'root'
})
export class UtilisateurService {
  private currentUserSubject = new BehaviorSubject<number | null>(null);
  currentUser$ = this.currentUserSubject.asObservable();
  private apiUrl = `${environment.apiUrl}/interne`;

  constructor(private http: HttpClient) {
  }

  getUsers(params?: any): Observable<UtilisateursResponse> {
    return this.http.get<UtilisateursResponse>(this.apiUrl, {params});
  }

  getUserById(id: string): Observable<UtilisateurResponse> {
    return this.http.get<UtilisateurResponse>(`${this.apiUrl}/${id}`);
  }

  postUser(utilisateurBody: UtilisateurBody): Observable<UtilisateurResponse> {
    return this.http.post<UtilisateurResponse>(this.apiUrl, utilisateurBody);
  }

  updateUser(id: string, utilisateurBody: UtilisateurBody): Observable<UtilisateurResponse> {
    return this.http.put<UtilisateurResponse>(`${this.apiUrl}/${id}`, utilisateurBody);
  }

  deleteUser(id: string): Observable<UtilisateurDeleteResponse> {
    return this.http.delete<UtilisateurDeleteResponse>(`${this.apiUrl}/${id}`);
  }

  getCurrentUserId(): number | null {
    return this.currentUserSubject.getValue();
  }

  setCurrentUser(userId: number) {
    this.currentUserSubject.next(userId);
  }
}
